<template>
	<DialogFormDialog
		ref="dialog"
		class="dialog"
		:strings="strings"
		@reset="reset"
	>
		<v-row>
			<v-col cols="5">
				<v-subheader>Current time</v-subheader>
			</v-col>
			<v-col cols="6">
				<v-select
					v-model="values.operator"
					:rules="rules"
					class="pt-0"
					:items="operators"
				/>
			</v-col>
		</v-row>
		<v-row>
			<v-col class="text-center" cols="12">
				<shared-time-field v-model="values.value" label="Time" :rules="rules" />
			</v-col>
		</v-row>
	</DialogFormDialog>
</template>

<script>
import _ from "lodash";

import strings from "@/utils/strings";

import { DATETIME_OPERATORS_MAP } from "@/services/k4/node/conditionNode";

const initData = () => ({
	values: {
		guid: null,
		dateType: "time",
		operator: "==",
		value: null,
	},
});

export default {
	data: initData,

	computed: {
		strings() {
			const _strings = strings.live.scenes.timeConditionDialog;
			return _.isNil(this.values.guid) ? _strings.new : _strings.update;
		},

		operators() {
			return _.map(DATETIME_OPERATORS_MAP, (value, key) => ({
				value: key,
				text: value,
			}));
		},

		rules() {
			return [(val) => !!val || "Required"];
		},
	},

	watch: {
		values: {
			deep: true,
			handler(newVal) {
				this.$refs.dialog.updateFormData(newVal);
			},
		},
	},

	methods: {
		reset() {
			Object.assign(this, initData());
		},

		pop(handler, node) {
			if (node) {
				this.values.guid = node.guid;
				this.values.operator = node.operator;
				this.values.value = node.value;
			}
			return this.$refs.dialog.pop(handler);
		},
	},
};
</script>
